import types from '@/types';
import InvitationService from '@/services/InvitationService';
import InvitationReportService from '@/services/invitationReportService';
import InvitationTypeService from '@/services/InvitationTypeService';
import IdentificationTypeService from '@/services/IdentificationTypeService';
import AreaService from '@/services/AreaService';
import StatusService from '@/services/StatusService';
import TransportTypeService from '@/services/TransportTypeService';
import TransportColorService from '@/services/TransportColorService';
import FaceDetectionLister from '@/services/FaceDetectionService';

const data = {
  invitationTypes: [],
  identificationTypes: [],
  guests: [],
  totalIntivations: 0,
  invitations: [],
  invitation: null,
  transportTypes: [],
  transportColors: [],
  schedule: null,
  areas: [
  ],
  invitationStatus: [
    { id: '', name: 'All' },
    { id: '1', name: 'Pending' },
    { id: '2', name: 'In House' },
    { id: '3', name: 'Check Out' },
    { id: '4', name: 'Cancelled' },
    { id: '5', name: 'Overdue In House' },
    { id: '6', name: 'Overdue Pending' },
  ],
  typeVisitorsCenter: process.env.TYPE_VISITORS_CENTER,
  typeSupplier: process.env.TYPE_SUPPLIER,
  projectsList: [],
  accessList: [],

};

const theGetters = {
};

const mutations = {
  [types.SET_INVITATION_TYPES](state, invitationTypes) {
    state.invitationTypes = invitationTypes;
  },
  [types.SET_IDENTIFICATION_TYPES](state, identificationTypes) {
    state.identificationTypes = identificationTypes;
  },
  [types.SET_GUESTS](state, guests) {
    state.guests = guests;
  },
  [types.SET_INVITATIONS](state, invitations) {
    state.invitations = invitations;
  },
  [types.SET_INVITATION](state, invitation) {
    state.invitation = invitation;
  },
  [types.SET_TRANSPORT_TYPES](state, transportTypes) {
    state.transportTypes = transportTypes;
  },
  [types.SET_TRANSPORT_COLORS](state, transportColors) {
    state.transportColors = transportColors;
  },
  [types.SET_SCHEDULE](state, schedule) {
    state.schedule = schedule;
  },
  [types.SET_AREAS](state, areas) {
    state.areas = areas;
  },
  [types.SET_STATUS](state, invitationStatus) {
    state.invitationStatus = invitationStatus;
  },
  SET_INVITATION_STATUS(state, { invitationId, status }) {
    const invitation = state.invitations.find((item) => item.id === invitationId);
    invitation.status = status;
  },
  SET_TOTAL_INVITATIONS(state, totalIntivations) {
    state.totalIntivations = totalIntivations;
  },
  SET_PROJECTS(state, listProjects) {
    state.projectsList = listProjects;
  },
  SET_CONTRACTORS_ACCESS(state, listAccess) {
    state.accessList = listAccess;
  },
};

const actions = {
  [types.GET_INVITATION_TYPES]({ commit }) {
    const invitationTypeService = new InvitationTypeService();
    return invitationTypeService.getList()
      .then((response) => {
        let invitationTypes = response.data.map((item) => ({
          ...item,
          description: item.name,
          is_personal: item.name.toLowerCase() !== 'supplier',
        }));
        invitationTypes = invitationTypes.sort((a, b) => {
          if (a.name > b.name) {
            return 1;
          }
          if (a.name < b.name) {
            return -1;
          }
          return 0;
        });
        commit(types.SET_INVITATION_TYPES, invitationTypes);
      });
  },
  [types.GET_INVITATIONS]({ commit }, params) {
    const invitationService = new InvitationService();
    return invitationService.getList(params)
      .then((response) => {
        commit(types.SET_INVITATIONS, response.data.results);
        commit('SET_TOTAL_INVITATIONS', response.data.count);
      });
  },
  [types.GET_INVITATIONS_REPORT]({ commit }, params) {
    const invitationService = new InvitationReportService();
    return invitationService.getList(params)
      .then((response) => {
        commit(types.SET_INVITATIONS, response.data);
        commit('SET_TOTAL_INVITATIONS', response.data.count);
      });
  },
  [types.GET_INVITATION]({ commit }, invitationId) {
    const invitationService = new InvitationService();
    return invitationService.get(invitationId)
      .then((response) => {
        commit(types.SET_INVITATION, response.data);
      });
  },
  [types.GET_INVITATION_CHECKIN]({ commit }, invitationId) {
    const invitationService = new InvitationService();
    return invitationService.getCheckin(invitationId)
      .then((response) => {
        commit(types.SET_INVITATION, response.data);
      });
  },
  [types.GET_INVITATION_CHECKOUT]({ commit }, invitationId) {
    const invitationService = new InvitationService();
    return invitationService.getCheckout(invitationId)
      .then((response) => {
        commit(types.SET_INVITATION, response.data);
      });
  },
  [types.GET_AREAS]({ commit }) {
    const areaService = new AreaService();
    return areaService.getList()
      .then((response) => {
        const areas = response.data;
        areas.unshift({ id: '', name: 'Todas' });
        commit(types.SET_AREAS, areas);
      });
  },
  [types.GET_STATUS]({ commit }) {
    const statusService = new StatusService();
    return statusService.getList()
      .then((response) => {
        const statusAllowed = ['Pending', 'In House', 'Overdue In House'];
        const status = response.data.filter((item) => statusAllowed.indexOf(item.name) > -1);
        status.unshift({ id: '', name: 'Todos' });
        commit(types.SET_STATUS, status);
      });
  },
  [types.GET_STATUS_REPORT]({ commit }) {
    const statusService = new StatusService();
    return statusService.getList()
      .then((response) => {
        const statusAllowed = ['Pending', 'In House', 'Overdue In House', 'Checked Out'];
        const status = response.data.filter((item) => statusAllowed.indexOf(item.name) > -1);
        status.unshift({ id: '', name: 'Todos' });
        commit(types.SET_STATUS, status);
      });
  },
  [types.GET_IDENTIFICATION_TYPES]({ commit }) {
    const identificationTypeService = new IdentificationTypeService();
    return identificationTypeService.getList()
      .then((response) => {
        const invitationTypes = response.data.map((item) => ({
          ...item,
          description: item.name,
        }));
        commit(types.SET_IDENTIFICATION_TYPES, invitationTypes);
      });
  },
  [types.GET_IDENTIFICATION_TYPES]({ commit }) {
    const identificationTypeService = new IdentificationTypeService();
    return identificationTypeService.getList()
      .then((response) => {
        const invitationTypes = response.data.map((item) => ({
          ...item,
          description: item.name,
        }));
        commit(types.SET_IDENTIFICATION_TYPES, invitationTypes);
      });
  },
  [types.GET_TRANSPORT_TYPES]({ commit }) {
    const transtportTypeService = new TransportTypeService();
    return transtportTypeService.getList()
      .then((response) => {
        const transportTypes = response.data.map((item) => ({
          ...item,
          description: item.name,
        }));
        commit(types.SET_TRANSPORT_TYPES, transportTypes);
      });
  },
  [types.GET_TRANSPORT_COLORS]({ commit }) {
    const transportColorService = new TransportColorService();
    return transportColorService.getList()
      .then((response) => {
        const transportColors = response.data.map((item) => ({
          ...item,
          description: item.name,
        }));
        commit(types.SET_TRANSPORT_COLORS, transportColors);
      });
  },
  [types.CHECK_IN]({ commit }, { invitationId, checkinForm }) {
    const invitationService = new InvitationService();
    return invitationService.checkin(invitationId, checkinForm)
      .then(() => {
        commit('SET_INVITATION_STATUS', { invitationId, status: 'In House' });
      });
  },
  [types.CHECK_OUT]({ commit }, invitationId) {
    const invitationService = new InvitationService();
    return invitationService.checkout(invitationId)
      .then(() => {
        commit('SET_INVITATION_STATUS', { invitationId, status: 'Check Out' });
      });
  },
  [types.LIST_PROJECTS]({ commit }) {
    const faceDetectionLister = new FaceDetectionLister();
    return faceDetectionLister.getListProjects()
      .then((response) => {
        commit('SET_PROJECTS', response.data);
      });
  },
  [types.LIST_ACCESS]({ commit }, params) {
    const faceDetectionLister = new FaceDetectionLister();
    return faceDetectionLister.getListAccesses(params)
      .then((response) => {
        commit(types.SET_CONTRACTORS_ACCESS, response.data);
        // commit('SET_TOTAL_INVITATIONS', response.data.count);
      });
  },
  async [types.SETUP_BACKOFFICE]({ dispatch }) {
    await dispatch(types.GET_AREAS);
    await dispatch(types.GET_STATUS);
    await dispatch(types.GET_INVITATION_TYPES);
    await dispatch(types.GET_IDENTIFICATION_TYPES);
    await dispatch(types.GET_TRANSPORT_TYPES);
    await dispatch(types.GET_TRANSPORT_COLORS);
  },
  async [types.SETUP_BACKOFFICE_REPORT]({ dispatch }) {
    await dispatch(types.GET_AREAS);
    await dispatch(types.GET_STATUS_REPORT);
    await dispatch(types.GET_INVITATION_TYPES);
    await dispatch(types.GET_IDENTIFICATION_TYPES);
    await dispatch(types.GET_TRANSPORT_TYPES);
    await dispatch(types.GET_TRANSPORT_COLORS);
  },
  async [types.SETUP_FACE_CONTROL_ACCESS]({ dispatch }) {
    await dispatch(types.LIST_PROJECTS);
  },
};

export default {
  namespaced: true,
  state: data,
  getters: theGetters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/invitation.js